import { Route } from '@angular/router';
import { agencyActivationResolver } from './agency-activation.resolver';
import { ActivationTokenComponent } from './feat-activation-token/activation-token.component';
import { AgencyActivationComponent } from './feat-agency-activation/agency-activation.component';

export const activationRoutes: Route[] = [
  {
    path: 'agency/activation/:activationCode',
    component: AgencyActivationComponent,
    resolve: {
      activation: agencyActivationResolver,
    },
    data: {
      hideFooter: true,
      renownedBranding: true,
    },
  },
  {
    path: 'activate/profile',
    component: ActivationTokenComponent,
    data: {
      hideFooter: true,
      basicHeader: true,
      renownedBranding: true,
    },
  },
];
